import { useState } from "react";
import { toast } from "sonner";
import { Header } from "../../components/laxmi/Chrome";
import { api, err, money } from "../../lib/api";
import { useSite } from "../../lib/site";

const AMOUNTS = [110, 300, 500, 1000, 2000, 5000];

export default function Withdraw({ data, setPage, onDone }) {
  const { site } = useSite();
  const [amount, setAmount] = useState("300"), [method, setMethod] = useState("UPI"), [holder, setHolder] = useState(""), [account, setAccount] = useState(""), [ifsc, setIfsc] = useState(""), [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/wallet/withdraw", { amount: Number(amount), method, account_holder: holder, account, ifsc: method === "Bank" ? ifsc : null });
      toast.success("Withdrawal requested. It will be processed after review.");
      await onDone(); setPage("history");
    } catch (e) { toast.error(err(e)); }
    setBusy(false);
  };
  return (
    <div className="screen">
      <Header title="Withdraw" onBack={() => setPage("account")} onBell={() => setPage("notifications")} />
      <section className="balance-card compact"><span>💰 Available balance</span><strong data-testid="withdraw-balance">{money(data.wallet.balance)}</strong></section>
      <section className="action-panel">
        <h2>Withdraw to</h2>
        <div className="filter-row">{["UPI", "Bank"].map(m => <button key={m} className={method === m ? "selected" : ""} onClick={() => setMethod(m)} data-testid={`withdraw-method-${m.toLowerCase()}`}>{m === "UPI" ? "UPI" : "Bank account"}</button>)}</div>
        <input className="utr-input" value={holder} onChange={e => setHolder(e.target.value)} placeholder="Account holder name" data-testid="withdraw-holder-input" />
        <input className="utr-input" value={account} onChange={e => setAccount(e.target.value)} placeholder={method === "UPI" ? "UPI ID (e.g. name@upi)" : "Bank account number"} data-testid="withdraw-account-input" />
        {method === "Bank" && <input className="utr-input" value={ifsc} onChange={e => setIfsc(e.target.value)} placeholder="IFSC code" data-testid="withdraw-ifsc-input" />}
        <h2 className="mt">Withdraw amount</h2>
        <div className="amounts">{AMOUNTS.map(n => <button className={Number(amount) === n ? "selected" : ""} onClick={() => setAmount(String(n))} key={n} data-testid={`amount-${n}-button`}>₹{n}</button>)}</div>
        <input data-testid="withdraw-amount-input" value={amount} onChange={e => setAmount(e.target.value)} type="number" />
        <p className="demo-note">Minimum withdrawal {money(site.min_withdraw)} · Amount is held until admin review</p>
        {data.bonus?.remaining > 0 && <p className="wager-lock" data-testid="withdraw-wagering-lock">Wagering pending: {money(data.bonus.progress)} / {money(data.bonus.required)} · Play {money(data.bonus.remaining)} more to withdraw</p>}
        <button className="primary-button" onClick={submit} disabled={busy} data-testid="withdraw-submit-button">{busy ? "Submitting…" : "Request withdrawal"}</button>
      </section>
    </div>
  );
}
